
import React from 'react';
import Icon from 'react-icon-base';

const DmiInfo = props => (
  <Icon viewBox="0 0 20 20" {...props}>
    <g>
      <g fill="none" fillRule="evenodd">
        <path d="M-2-2h24v24H-2z" />
        <path fill="currentColor" fillRule="nonzero" d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9V9h2v6zm0-8H9V5h2v2z" />
      </g>
    </g>
  </Icon>
);

export default DmiInfo;
